import server from 'common/utils/server';

export const setCompanyFeatureValue = ({ name, value }) => dispatch => {
  dispatch({
    type: 'SET_COMPANY_FEATURE',
    name,
    value,
  });
  const url = `/api/v1/company_features/${name}`;
  return value ? server.post(url) : server.delete(url);
};

export function companyFeatures(state = {}, action) {
  switch (action.type) {
    case 'INITIALIZATION_DATA': {
      return action.data.companyFeatures || {};
    }
    case 'SET_COMPANY_FEATURE': {
      const { name, value } = action;
      return {
        ...state,
        [name]: value,
      };
    }
    default: {
      return state;
    }
  }
}
